import { MouseEvent } from 'react';
import { useRecoilValue } from 'recoil';

import useUpdateEffect from '@/hooks/useUpdateEffect';
import { cameraPermissionState } from '@/recoil/chat';

const useCheckCameraPermission = () => {
    const cameraPermission = useRecoilValue(cameraPermissionState);

    useUpdateEffect(() => {
        if (cameraPermission) {
            const check = document.getElementById('file');
            check?.click();
        }
    }, [cameraPermission]);

    const checkCameraPermission = (e: MouseEvent<HTMLInputElement>) => {
        if (!cameraPermission) e.preventDefault();

        if (window.ReactNativeWebView)
            window.ReactNativeWebView.postMessage(JSON.stringify({ cameraPermission: true }));
    };

    return { checkCameraPermission };
};

export default useCheckCameraPermission;
